import React from "react";
import SignForm from "../component/Register/SignForm";

const SignUpPage = () => {

  return (
    <section className="text-gray-900 transition-colors bg-bg-light-primary dark:bg-bg-dark-primary dark:text-gray-100">
      <div className="">
        <SignForm />
      </div>
    </section>
  );
};

export default SignUpPage;
